module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_ladyaustin.465a4913.jpg";